(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      if (!motion.matches) entry.target.classList.add('rh-card-arrived');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.08 }) : null;
  function init(scope = document) {
    scope.querySelectorAll('[data-rh-finder]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const tabs = [...root.querySelectorAll('[data-rh-occasion]')];
      const panels = [...root.querySelectorAll('[data-rh-occasion-panel]')];
      root.querySelector('[data-rh-finder-tabs]').setAttribute('role','tablist');
      tabs.forEach((tab,i) => {
        tab.id = panels[i].id + '-tab';
        tab.setAttribute('role','tab');
        tab.setAttribute('aria-controls',panels[i].id);
        panels[i].setAttribute('role','tabpanel');
        panels[i].setAttribute('aria-labelledby',tab.id);
        panels[i].tabIndex = 0;
      });
      function select(index, focus = false) {
        tabs.forEach((tab,i) => {
          tab.setAttribute('aria-selected',String(i===index));
          tab.tabIndex = i===index ? 0 : -1;
          panels[i].hidden = i!==index;
        });
        if (focus) tabs[index].focus();
      }
      tabs.forEach((tab,i) => {
        tab.addEventListener('click',event=>{event.preventDefault();select(i);});
        tab.addEventListener('keydown',event=>{
          let next;
          if(event.key==='ArrowRight') next=(i+1)%tabs.length;
          if(event.key==='ArrowLeft') next=(i+tabs.length-1)%tabs.length;
          if(event.key==='Home') next=0;
          if(event.key==='End') next=tabs.length-1;
          if(event.key===' ') next=i;
          if(next!==undefined){event.preventDefault();select(next,true);}
        });
      });
      const hashIndex=panels.findIndex(p=>'#'+p.id===location.hash);
      select(hashIndex<0?0:hashIndex);
      root.classList.add('is-enhanced');
      // Warm up alternate photos shortly before the visitor reaches the selector.
      if ('IntersectionObserver' in window) {
        const photoObserver = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          root.querySelectorAll('img').forEach(img => { img.loading = 'eager'; });
          photoObserver.disconnect();
        }, { rootMargin: '600px' });
        photoObserver.observe(root);
      }
    });
    scope.querySelectorAll('[data-rh-grid-controls]').forEach(control=>{
      if(control.dataset.ready) return;
      control.dataset.ready='true';
      const collection=control.closest('.collection');
      control.hidden=false;
      control.addEventListener('click',event=>{
        const button=event.target.closest('[data-rh-grid]');
        if(!button) return;
        const airy=button.dataset.rhGrid==='airy';
        collection.classList.toggle('rh-grid-airy',airy);
        collection.classList.toggle('rh-grid-compact',!airy);
        control.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
      });
    });
    if(observer && !motion.matches) scope.querySelectorAll('.product-grid>li,.edition-contact-grid>.edition-product-card,.edition-pair-card,.rh-contact__card').forEach((card,i)=>{
      if(seen.has(card)) return;
      seen.add(card);
      // Above-fold content stays untouched; content never starts hidden.
      if(card.getBoundingClientRect().top<innerHeight) return;
      card.style.setProperty('--rh-card-delay',`${i%3*65}ms`);
      observer.observe(card);
    });
  }
  init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
